import { createAsyncThunk } from '@reduxjs/toolkit';

import APIDataProvider, {
  TApiPaginationResponse,
  TApiResponse,
} from '../../../api/ApiDataProvider';
import { AdminApiPaths } from '../../../api/APIPaths';
import { ITutorRating } from '.';

export type TAdminGetTutorRatings = {
  limit: number;
  offset: number;
  tutorId?: string;
};

export type TAdminUpdateTutorRating = {
  id: string;
  rating?: number;
  feedback?: string;
};

const apiDataProvider = new APIDataProvider();

export const adminGetTutorRatings = createAsyncThunk(
  '/admin/tutor-ratings/list',
  async ({ limit, offset, tutorId }: TAdminGetTutorRatings) => {
    let path = `${AdminApiPaths.adminTutorRatings}?limit=${limit}&offset=${offset}`;

    if (tutorId) {
      path += `&tutorId=${tutorId}`;
    }

    const response = await apiDataProvider.get<
      TApiResponse<TApiPaginationResponse<ITutorRating>>
    >(path);

    return response.data;
  }
);

export const adminUpdateTutorRating = createAsyncThunk(
  '/admin/tutor-ratings/update',
  async ({ id, ...data }: TAdminUpdateTutorRating) => {
    const response = await apiDataProvider.put<TApiResponse<ITutorRating>>(
      `${AdminApiPaths.adminTutorRatings}/${id}`,
      data
    );

    return response.data;
  }
);

export const adminDeleteTutorRating = createAsyncThunk(
  '/admin/tutor-ratings/delete',
  async (id: string) => {
    await apiDataProvider.delete(`${AdminApiPaths.adminTutorRatings}/${id}`);

    return id;
  }
);
